import cx from 'classnames'
import Styles from './AIAssistant.module.scss'
import { ChannelType } from 'components/CampaignCreationModal/Types'
import { Card, Content } from 'components/DocRightRail/screens/AIAssistant/Card'
import { HistoryButton } from 'components/DocRightRail/screens/AIAssistant/HistoryButton'
import { Skeleton } from 'antd'
import { EventWizardButton, NonChannelWizard } from 'components/DocRightRail/screens/AIAssistant/EventWizardButton'
import { ActivityEventSwitch } from 'components/ActivityEvent/ActivityEvent'
import { TimelineEventType } from 'screens/Activity/Types'
import { ActivityEvent } from 'components/ActivityEvent/Types'
import { useState } from 'react'
import { useLastEvent } from 'hooks/useLastEvent'
import { ArticleFlat } from 'types'

interface Props {
  event: ActivityEvent
}

const Loading = () => (
  <Card>
    <Content>
      <div className={cx(Styles.contentWrapper, Styles.previousCard)}>
        <div className={Styles.cardTitle}>What last happened</div>
        <Skeleton className={cx(Styles.skeleton, Styles.lg)} paragraph={false} active />
        <Skeleton className={cx(Styles.skeleton, Styles.md)} paragraph={false} active />
        <Skeleton className={cx(Styles.skeleton, Styles.sm)} paragraph={false} active />
      </div>
    </Content>
  </Card>
)

const PreviousActionCard = ({ event }: Props) => {
  const [isTruncated, setIsTruncated] = useState(true)

  return (
    <Card>
      <Content>
        <div className={cx(Styles.contentWrapper, Styles.previousCard)}>
          <div className={Styles.cardTitle}>What last happened</div>
          <div className={Styles.content}>
            <div className={Styles.typeContent}>
              <ActivityEventSwitch
                onClick={() => setIsTruncated((expanded) => !expanded)}
                isTruncated={isTruncated}
                event={event}
                actionsEnabled={false}
                isLast={false}
                isStatic
                className={Styles.activityEvent}
                openWizard={false}
              />
            </div>
          </div>
        </div>
      </Content>
      <div className={Styles.cardFooter}>
        <HistoryButton event={event} />
        {event.type === TimelineEventType.ArticleAIGeneratedEvent &&
          [...Object.values(ChannelType), ...Object.values(NonChannelWizard)].includes(
            event.data.generation_type as ChannelType,
          ) && <EventWizardButton event={event} />}
      </div>
    </Card>
  )
}

interface DynamicProps extends Partial<Props> {
  loading: boolean
}

const DynamicPreviousActionCard = ({ event, loading }: DynamicProps) => (
  <>
    {loading && !event && <Loading />}
    {event && <PreviousActionCard event={event} />}
  </>
)

interface ContainerProps {
  article: ArticleFlat
  layerId: string
}

export const PreviousActionCardContainer = ({ article, layerId }: ContainerProps) => {
  const { lastEvent, loading } = useLastEvent({ articleId: article.id, layerId })

  return <DynamicPreviousActionCard loading={loading} event={lastEvent} />
}

export { DynamicPreviousActionCard as PreviousActionCard }
